import { observer } from "mobx-react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import doctorClinicMismatchPromptStore from "../../stores/DoctorClinicJoin/doctorClinicMismatchPromptStore";

/**
 * Global dialog shown when an Rx is about to be saved with a LANR and a BSNR
 * that do not belong together. Rendered once at the app root; driven by
 * `doctorClinicMismatchPromptStore`.
 *
 * Closing via backdrop/escape counts as "go back" — the non-destructive choice
 * here is NOT saving, because the prescription leaves the practice and would
 * carry the wrong telephone number. Saving anyway stays one click away, since
 * a doctor may genuinely work at a practice nobody has assigned yet.
 */
const DoctorClinicMismatchDialog = observer(() => {
  const { open, context } = doctorClinicMismatchPromptStore;

  const doctorLabel = context
    ? [context.doctorName, context.doctorLANR && `(LANR ${context.doctorLANR})`]
        .filter(Boolean)
        .join(" ")
        .trim()
    : "";
  const clinicLabel = context
    ? [context.clinicName, context.clinicBSNR && `(BSNR ${context.clinicBSNR})`]
        .filter(Boolean)
        .join(" ")
        .trim()
    : "";

  return (
    <Dialog
      open={open}
      onClose={() => doctorClinicMismatchPromptStore.cancel()}
      PaperProps={{ style: { zIndex: 2100 } }}
    >
      <DialogTitle>BSNR und LANR passen nicht zusammen</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {doctorLabel || "Dieser Arzt"} ist nicht in {clinicLabel || "dieser Praxis"} hinterlegt.
          Auf dem Rezept erscheinen dann Anschrift und Telefonnummer dieser Praxis, obwohl der Arzt
          nicht zu ihr gehört. Bitte prüfen Sie Betriebsstätten-Nr. und Arzt-Nr.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => doctorClinicMismatchPromptStore.cancel()}>Zurück zum Rezept</Button>
        <Button variant="contained" onClick={() => doctorClinicMismatchPromptStore.confirm()}>
          Trotzdem speichern
        </Button>
      </DialogActions>
    </Dialog>
  );
});

export default DoctorClinicMismatchDialog;
